<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>口座情報の登録・変更</HeadingOne>

    <p>お借り入れやご返済の際にご利用いただく口座のご登録・変更ができます。</p>

    <section v-if="userData.bank_name">
      <HeadingTwo>ご登録中の口座情報</HeadingTwo>

      <TableBox class="-members _mb-sm-40 _mb-md-60">
        <TableBody>
          <TableRow>
            <TableHeader>金融機関名</TableHeader>
            <TableData>{{ userData.bank_name }}</TableData>
          </TableRow>
          <TableRow>
            <TableHeader>支店名</TableHeader>
            <TableData>{{ userData.branch_name }}</TableData>
          </TableRow>
        </TableBody>
      </TableBox>
      <CardBox>
        <CardHeader>
          <h2 class="heading">口座登録・変更時のご注意事項</h2>
        </CardHeader>
        <CardBody>
          <ListGroup class="-normal">
            <ListItem class="-normal"
              >お手続きには金融機関の支店名、預金種目、口座番号などのご入力が必要なため、通帳、キャッシュカードなどのご準備をお願いします。</ListItem
            >
          </ListGroup>
          <ListGroup class="-normal">
            <ListItem class="-normal"
              >口座引落しによるご返済をご利用中のお客さまは、ご返済日までの期間が短い場合は、変更後の口座よりお引落しができないことがありますので、あらかじめご了承ください。</ListItem
            >
          </ListGroup>
        </CardBody>
      </CardBox>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-out" @click.prevent="showChangeModal">
          変更する
        </BtnMain>
      </BtngroupSingle>
    </section>

    <section v-else>
      <!-- 口座の登録情報がない場合 -->

      <HeadingTwo>ご登録中の口座情報</HeadingTwo>

      <p>登録されている口座はありません。</p>

      <CardBox>
        <CardHeader>
          <h2 class="heading">口座登録・変更時のご注意事項</h2>
        </CardHeader>
        <CardBody>
          <ListGroup class="-normal">
            <ListItem class="-normal"
              >お手続きには金融機関の支店名、預金種目、口座番号などのご入力が必要なため、通帳、キャッシュカードなどのご準備をお願いします。</ListItem
            >
          </ListGroup>
          <ListGroup class="-normal">
            <ListItem class="-normal"
              >口座引落しによるご返済をご利用中のお客さまは、ご返済日までの期間が短い場合は、変更後の口座よりお引落しができないことがありますので、あらかじめご了承ください。</ListItem
            >
          </ListGroup>
        </CardBody>
      </CardBox>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-out" @click.prevent="showChangeModal">
          口座を登録する
        </BtnMain>
      </BtngroupSingle>
    </section>

    <ModalWindow v-if="isShowModal" @close="hideChangeModal">
      <div class="row">
        <p>
          口座のご登録が完了していないお客さまは「口座の登録・変更へ戻る」を押して、改めて口座のご登録をお願いします。<br />
          インターネットで口座のご登録が完了したお客さまはブラウザを閉じてください。<br />
          ご登録いただいたメールアドレスに【お手続き完了のお知らせ】をお送りしておりますのでご確認ください
        </p>
        <BtngroupSingle>
          <BtnClose class="-close -md" @click.prevent="doReload"
            >口座の登録・変更へ戻る</BtnClose
          >
        </BtngroupSingle>
      </div>
    </ModalWindow>
  </div>
  <!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";

import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import CardBox from "@/components/card/CardBox";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import ModalWindow from "@/components/modal/ModalWindow";
import BtnClose from "@/components/button/BtnClose";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb021",
  components: {
    BtnClose,
    ModalWindow,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtnMain,
    BtngroupSingle,
    ListGroup,
    ListItem,
    CardBox,
    CardBody,
    CardHeader,
    HeadingTwo,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "口座情報の登録・変更",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,口座情報",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "口座情報の登録・変更",
          active: true,
        },
      ],
      isShowModal: false,
      userData: {
        bank_name: "",
        branch_name: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    showChangeModal() {
      window.open("/koufuri_request_member.html", "_blank");
      this.isShowModal = true;
    },
    hideChangeModal() {
      this.isShowModal = false;
    },
    doReload() {
      window.open("/member/account", "_self");
    },
  },
};
</script>

<style scoped></style>
